module.exports = __webpack_public_path__ + "img/baloo-men-camp_3x-min.a4dbfbe.webp";